import React, { useContext } from "react";
import Label from "~/componentes/CustomForm/Label";
import { Input, TextArea, Select } from "~/componentes/CustomForm";
import ColoredButton from "~/componentes/Button/Styles/ColoredButton";
import sistemaListStore from "../../../../../../componentes/SistemaList/ThisMainComponent/thisStore";
import { useState } from "react";
import { useEffect } from "react";

import { CardAtividade, Container } from "./styles";
import IconModalOrcamentoAtividade from '~/assets/icones/modal/IconModalOrcamentoAtividade.svg';
import api from "~/services/api";

function EtapaDataList({ defaultData, setter, etapasList, dataInicio }) {
  const [etapas, setEtapas] = useState([]);
  const { state } = useContext(sistemaListStore);
  const { create, edit, editShow } = state?.modal || {};

  useEffect(() => {
    if (Array.isArray(defaultData)) {
      if (defaultData?.length > 0) {
        if (edit) {
          let aEtapa = [];
          let item = 1;
          for (const itemEtapa of defaultData) {
            aEtapa.push({
              item,
              id: itemEtapa?.id,
              idEtapa: itemEtapa?.idEtapa,
              status: itemEtapa?.status,
              titulo: itemEtapa?.etapa?.titulo,
              dateDataPrevEntrega: new Date(itemEtapa?.dataPrevEntrega), 
              dataPrevEntrega: itemEtapa?.dataPrevEntrega,
              diasLimiteExecucao: itemEtapa?.etapa?.diasLimiteExecucao,
            });

            item++;
          }
          setEtapas(aEtapa);
          setter(aEtapa);
        }
      } else if (etapasList?.length > 0){
        if (edit || create) {
          let item = 1;
          let aEtapa = [];
          let diaInicial = new Date(dataInicio);

          for (const itemEtapa of etapasList) {
            let find = defaultData?.find((e) => e?.id == itemEtapa?.id);

            diaInicial.setDate(diaInicial.getDate() + itemEtapa?.diasLimiteExecucao);
            aEtapa.push({ 
              item, 
              idEtapa: itemEtapa?.id, 
              titulo: itemEtapa?.titulo, 
              dateDataPrevEntrega: diaInicial, 
              dataPrevEntrega: find?.dataPrevEntrega ? find?.dataPrevEntrega : diaInicial.toISOString().slice(0, 10), 
              posicao: itemEtapa?.posicao,
              diasLimiteExecucao: itemEtapa?.diasLimiteExecucao,
            });
            
            item++;
          }

          setEtapas(aEtapa);
          setter(aEtapa);
        }
      }
    }
  }, [edit, editShow, etapasList, dataInicio]);

  useEffect(() => {
    setter(etapas);
  }, [etapas]);
  
  return (
    <Container>
      <Label title="Etapas *" row={true}>
      </Label>
      <CardAtividade>
        <div className="card-atv-header">
          <div className="titulos-tab">
            <div className="item w5">
              <p className="titulo">Título <span>*</span></p>
            </div>
            <div className="item w3">
              <p className="titulo">Status <span>*</span></p>
            </div>
            <div className="item w3">
              <p className="titulo">Data Maxima <span>*</span></p>
            </div>
          </div>
        </div>
        <div className="card-atv-body">
          {etapas?.map((itemData, index) => (
            <div className="row no-margin row-top">
              <div className="w5">
                <Input
                  placeholder="Titulo da Atividade"
                  name="tituloAtividadeAt"
                  required="true"
                  value={itemData?.titulo}
                  disabled="true"
                />
              </div>
              <div className="w3">
                <Select
                  required="true"
                  isString
                  list={{ list: [{ id: "N", titulo: "Não Iniciado" }, { id: "E", titulo: "Em Andamento" }, { id: "C", titulo: "Concluído" }], value: "id", label: "titulo" }}
                  name="statusAt"
                  defaultValue={itemData?.status}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "N";
                    setEtapas((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].status = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Input
                  type="date"
                  name="dataPrevEntregaAt"
                  value={itemData?.dataPrevEntrega}
                  required={false}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setEtapas((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].dataPrevEntrega = v;
                      newPrev[index].dateDataPrevEntrega = new Date(v);
                      
                      let diaInicial = newPrev[index].dateDataPrevEntrega;

                      for (let countI = index + 1; countI < newPrev?.length; countI++) {
                        diaInicial.setDate(diaInicial.getDate() + newPrev[countI]?.diasLimiteExecucao);
                        
                        newPrev[countI].dataPrevEntrega = diaInicial.toISOString().slice(0, 10);
                        newPrev[countI].dateDataPrevEntrega = diaInicial;
                      }

                      return newPrev;
                    });
                  }}
                />
              </div>
            </div>
           ))}
        </div>
      </CardAtividade>
      {/* ))} */}
    </Container>
  );
}

export default EtapaDataList;
